export const openImageHandler = (event, setImageX, setImageY) => {
    let screenWidth = window.innerWidth / 2
    let screenHeight = window.innerHeight / 2
    let xPos = (event.clientX - screenWidth)
    let yPos = (event.clientY - screenHeight)
    setImageX(xPos)
    setImageY(yPos)
}